
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-payment",
      function () {
        return require("private-next-pages/e-payment/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-payment"])
      });
    }
  